import { useCallback } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useUnit } from 'effector-react';
import { $portalSettings } from '@nx-frontend/shared/store/portal';
import { $isCustomizerMode } from '@nx-frontend/shared/store/portal-app';
import { MenuItemType, MenuType, PORTAL_QUERY_ACTION } from '@nx-frontend/shared/types';

export const useNavigateToAction = () => {
  const [isCustomizer, portalSettings] = useUnit([$isCustomizerMode, $portalSettings]);
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();

  return useCallback(
    ({
      action,
      itemId,
      itemType,
      menuType,
      parentId,
    }: {
      action: PORTAL_QUERY_ACTION;
      itemId?: string;
      itemType?: MenuItemType;
      menuType?: MenuType;
      parentId?: string;
    }) => {
      const currentParams = new URLSearchParams(searchParams);
      currentParams.set('action-type', action);
      if (itemType) {
        currentParams.set('action-entity-type', itemType);
      }
      if (menuType) {
        currentParams.set('action-menu-type', menuType);
      }
      if (itemId) {
        currentParams.set('action-item-id', itemId);
      }
      if (parentId) {
        currentParams.set('action-parent-id', parentId);
      }
      const preparedParams = currentParams.toString();
      if (isCustomizer) {
        window.history.pushState({}, '', `${pathname}?${preparedParams}`);
      } else {
        router.push(`/portal/${portalSettings.id}/visual?${preparedParams}`);
      }
    },
    [isCustomizer, pathname, portalSettings, router, searchParams]
  );
};
